import React from "react";

interface RedAlertIconProps {
  width?: number;
  height?: number;
}

const RedAlertIcon: React.FC<RedAlertIconProps> = ({ width = 20, height = 20 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#ED4A4A" />
      <path
        d="M10.9701 5.70482C10.9055 5.57876 10.8074 5.47297 10.6865 5.39909C10.5657 5.32522 10.4268 5.28613 10.2852 5.28613C10.1435 5.28613 10.0046 5.32522 9.88377 5.39909C9.76292 5.47297 9.6648 5.57876 9.60022 5.70482L5.36748 14.1702C5.30845 14.2874 5.28034 14.4177 5.28583 14.5488C5.29132 14.6798 5.33023 14.8073 5.39885 14.9191C5.46748 15.0309 5.56355 15.1233 5.67793 15.1876C5.79232 15.2518 5.92123 15.2857 6.05242 15.2861H14.5179C14.6491 15.2857 14.778 15.2518 14.8924 15.1876C15.0068 15.1233 15.1028 15.0309 15.1715 14.9191C15.2401 14.8073 15.279 14.6798 15.2845 14.5488C15.29 14.4177 15.2619 14.2874 15.2028 14.1702L10.9701 5.70482Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.4629 8.85742V11.1789" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.4637 13.1433C10.3651 13.1433 10.2852 13.0633 10.2852 12.9647C10.2852 12.8661 10.3651 12.7861 10.4637 12.7861"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4629 13.1433C10.5615 13.1433 10.6415 13.0633 10.6415 12.9647C10.6415 12.8661 10.5615 12.7861 10.4629 12.7861"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RedAlertIcon;
